<div class="d-flex justify-content-between">
  <h2 class="content-with-tabs-content-title-v2 mb-3" [innerHTML]="_title"></h2>
</div>
<div class="content-with-tabs-content-subtitle_sm-v2 mb-3" *ngIf="_subtitle" [innerHTML]="_subtitle"></div>
